/**
 * Created by pyt on 1/18/17.
 */
export const CREATE_ADVERTISER = 'CREATE_ADVERTISER';
export const SAVE_ADVERTISER = 'SAVE_ADVERTISER';
export const UPDATE_ADVERTISER = 'UPDATE_ADVERTISER';
export const UPDATE_ADVERTISERS_LIST = 'UPDATE_ADVERTISERS_LIST';
export const UPDATE_ADVERTISERS_WITH_BUYER_LIST = 'UPDATE_ADVERTISERS_WITH_BUYER_LIST';
export const UPDATE_UNIQUE_ADVERTISERS_LIST = 'UPDATE_UNIQUE_ADVERTISERS_LIST';
export const UPDATE_AVAILABLE_ADVERTISERS_LIST = 'UPDATE_AVAILABLE_ADVERTISERS_LIST';
